<div style="width: 10%">
  <div class="text-muted small mb-1">{{'pages.lookup.single.result.alert.risk' | translate }}</div>
  <div class="text-uppercase"><span [ngClass]="'bg-' + riskClass(alert)" class="badge">{{('pages.lookup.single.result.alert_risk.' + alert.risk | translate)}}</span></div>
</div>

<div style="width: 20%">
  <div class="text-muted small mb-1">{{'pages.lookup.channel' | translate }}</div>
  <div class="fw-semibold">{{ alert.list!.owner }}&nbsp;/&nbsp;{{ alert.list!.vertical }}&nbsp;/&nbsp;{{ alert.list!.code }}</div>
</div>

<div style="width: 12%">
  <div class="text-muted small mb-1">{{'pages.lookup.single.result.alert.list_record' | translate }}</div>
  <div class="justify-content-around">
    <button (click)="view($event, alert)" type="button" class="btn text-action-2 fs-5 fw-bolder p-0">
      {{alert.reference}}
    </button>
  </div>
</div>

<div style="width: 37%">
  <div class="text-muted small mb-1">{{'pages.lookup.single.result.alert.info' | translate }}</div>
  <div class="text-truncate-custom fw-semibold">{{ alert.info }}</div>
</div>

<div style="width: 5%">
  <div class="text-muted small mb-1">{{'pages.lookup.single.result.alert.hits' | translate }}</div>
  <div class="fw-semibold text-dark">{{ alert.hits.length }}</div>
</div>

<!--<div style="width: 7%">-->
<!--  <div class="text-muted small mb-1">{{'pages.lookup.single.result.alert.worst' | translate }}</div>-->
<!--  <div class="fw-bold"><span [ngClass]="'text-' + riskClass(alert)">{{ (100*worstScore(alert)!).toFixed(1) }}&nbsp;%</span></div>-->
<!--</div>-->

<div style="width: 9%">
  <div class="text-muted small mb-1">{{'pages.lookup.single.result.alert.best' | translate }}</div>
  <div class="fw-bold"><span [ngClass]="'fw-bolder'">{{ (100*bestScore(alert)!).toFixed(1) }}&nbsp;%</span></div>
</div>

<div style="width: 7%">
  <div class="text-muted small mb-1">{{'pages.lookup.single.result.alert.score' | translate }}</div>
  <div class="fw-bold"><span [ngClass]="'text-' + riskClass(alert)">{{alert.result?.toFixed(1)}}</span></div>
</div>
